module.exports = __webpack_public_path__ + "static/img/ranjana.7bee1c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Events/IndraDhanush/IndraDhanush-pics/ranjana.jpg
// module id = ulPN
// module chunks = 0